module.exports = __webpack_public_path__ + "img/1w.6841d767.svg";